import { Unit } from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export type BrokeredOrderLineItemUpdateInput = {
  id?: string | null;
  itemId?: string;
  quantity?: number;
  unit?: Unit;
  notes?: string | null;
};

export const brokeredOrderUpdateAtom = createMutationAtomFactory(
  'brokerage.brokeredOrderUpdate',
  (params: {
    id: string;
    orderNumber?: string | null;
    notes?: string | null;
    lineItems?: BrokeredOrderLineItemUpdateInput[];
  }) => ({
    tradeBrokeredOrderUpdate: {
      __args: {
        id: params.id,
        input: {
          orderNumber: params.orderNumber,
          notes: params.notes,
          lineItems: params.lineItems,
        },
      },
      id: true,
      orderNumber: true,
      status: true,
      purchaseTotal: {
        amount: true,
        currencyCode: true,
      },
      salesTotal: {
        amount: true,
        currencyCode: true,
      },
      margin: {
        amount: true,
        currencyCode: true,
      },
      marginPercent: true,
      lineItems: {
        id: true,
        itemId: true,
        item: {
          id: true,
          name: true,
        },
        quantity: true,
        unit: true,
        purchaseUnitPrice: {
          amount: true,
          currencyCode: true,
        },
        salesUnitPrice: {
          amount: true,
          currencyCode: true,
        },
        purchaseTotal: {
          amount: true,
          currencyCode: true,
        },
        salesTotal: {
          amount: true,
          currencyCode: true,
        },
        margin: {
          amount: true,
          currencyCode: true,
        },
        marginPercent: true,
        notes: true,
      },
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
